/* KASED theme — global interactions (vanilla JS, no deps) */
(function () {
  var to = document.getElementById('toast'), tm = document.getElementById('toastMsg'), tt;
  function toast(msg){ if(!to) return; tm.textContent = msg; to.classList.add('show'); clearTimeout(tt); tt = setTimeout(function(){ to.classList.remove('show'); }, 2600); }
  window.kasedToast = toast;

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
    }).catch(function(){});
  }
  refreshCart();

  /* mobile drawer */
  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  function closeDrawer(){ if(drawer){ drawer.classList.remove('open'); overlay.classList.remove('open'); } }
  var burger = document.querySelector('[data-burger]');
  if(burger){ burger.addEventListener('click', function(){ drawer.classList.add('open'); overlay.classList.add('open'); }); }
  if(overlay){ overlay.addEventListener('click', closeDrawer); }
  var dc = document.querySelector('[data-drawer-close]');
  if(dc){ dc.addEventListener('click', closeDrawer); }

  /* accordion */
  document.querySelectorAll('details.faq > summary').forEach(function(sum){
    var d = sum.parentElement, ans = d.querySelector('.ans');
    sum.addEventListener('click', function(e){
      e.preventDefault();
      if(d.hasAttribute('open')){ ans.style.maxHeight = 0; d.removeAttribute('open'); }
      else { d.setAttribute('open',''); ans.style.maxHeight = ans.scrollHeight + 'px'; }
    });
  });

  /* scroll reveal */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.1});
    document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); }); }

  /* hero slider */
  (function(){
    var hero = document.querySelector('[data-hero]'); if(!hero) return;
    var slides = hero.querySelectorAll('[data-slide]'); if(slides.length < 2) return;
    var dots = hero.querySelectorAll('[data-dots] button'); var i = 0, timer;
    function go(n){ slides[i].style.display='none'; if(dots[i]) dots[i].setAttribute('aria-pressed','false'); i=(n+slides.length)%slides.length; slides[i].style.display=''; if(dots[i]) dots[i].setAttribute('aria-pressed','true'); }
    function start(){ timer=setInterval(function(){ go(i+1); },6000); }
    dots.forEach(function(d,idx){ d.addEventListener('click',function(){ clearInterval(timer); go(idx); start(); }); });
    if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){ start(); }
  })();

  /* gallery thumbs */
  (function(){
    var mainImg = document.getElementById('pdp-main-img'); if(!mainImg) return;
    document.querySelectorAll('.gallery .thumbs button').forEach(function(b){
      b.addEventListener('click', function(){
        mainImg.src = b.getAttribute('data-img');
        document.querySelectorAll('.gallery .thumbs button').forEach(function(x){ x.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true');
      });
    });
  })();

  /* collapsible model selector */
  (function(){
    document.querySelectorAll('[data-collapsible-toggle]').forEach(function(btn){
      var box = btn.previousElementSibling;
      if(!box || !box.hasAttribute('data-collapsible')) return;
      var label = btn.textContent;
      btn.addEventListener('click', function(){
        var open = box.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'Show less' : label;
      });
    });
    /* if the chosen model is hidden below the fold, open automatically */
    document.querySelectorAll('[data-collapsible]').forEach(function(box){
      var active = box.querySelector('[aria-pressed="true"]');
      if(active && active.offsetTop > 110){ var t = box.nextElementSibling; if(t && t.hasAttribute('data-collapsible-toggle')){ t.click(); } }
    });
  })();

  /* strip images out of the product description */
  (function(){
    document.querySelectorAll('.pdp-accordion .rte img, .pdp-accordion .rte picture, .pdp-accordion .rte video').forEach(function(el){ el.remove(); });
  })();

  /* PRODUCT variants + add to cart */
  (function(){
    var form = document.querySelector('form[action="/cart/add"]') || document.querySelector('form[action$="/cart/add"]');
    var data = document.getElementById('product-variants');
    if(!form || !data) return;
    var variants = JSON.parse(data.textContent);
    var selected = {};
    form.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx = group.getAttribute('data-opt-index');
      var active = group.querySelector('[aria-pressed="true"]');
      if(active){ selected[idx] = active.getAttribute('data-opt-value'); }
    });
    function colorTheme(val){ val=(val||'').toLowerCase();
      if(val.indexOf('pink')>-1 && val.indexOf('blush')===-1) return 'pink';
      if(val.indexOf('black')>-1 || val.indexOf('stealth')>-1) return 'black';
      if(val.indexOf('mono')>-1 || val.indexOf('grey')>-1 || val.indexOf('gray')>-1) return 'mono';
      if(val.indexOf('blush')>-1 || val.indexOf('rose')>-1) return 'blush'; return null; }
    function money(c){ try { return (c/100).toLocaleString(undefined,{style:'currency',currency:window.KASED_CURRENCY||'EUR'}); } catch(e){ return '€'+(c/100).toFixed(2); } }
    function currentVariant(){ return variants.find(function(v){ return v.options.every(function(o,i){ return selected[i]===o; }); }); }
    function update(){
      var v = currentVariant();
      var addBtn = form.querySelector('[data-add-btn]');
      var mobileBtn = document.querySelector('[data-add-mobile]');
      if(v){
        document.getElementById('variant-id').value = v.id;
        document.querySelectorAll('[data-price-now]').forEach(function(el){ el.textContent = money(v.price); });
        var kl = document.querySelector('[data-klarna]'); if(kl){ kl.textContent = money(Math.round(v.price/3)); }
        if(v.featured_image && v.featured_image.src){ var mi=document.getElementById('pdp-main-img'); if(mi){ mi.src = v.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i,'_1400x$1$2'); } }
        if(v.available){ if(addBtn){addBtn.disabled=false;addBtn.textContent=addBtn.getAttribute('data-label');} if(mobileBtn){mobileBtn.disabled=false;} }
        else { if(addBtn){addBtn.disabled=true;addBtn.textContent='Sold out';} if(mobileBtn){mobileBtn.disabled=true;} }
      } else if(addBtn){ addBtn.disabled=true; addBtn.textContent='Unavailable'; }
    }
    form.querySelectorAll('[data-opt-index]').forEach(function(group){
      var idx = group.getAttribute('data-opt-index');
      group.addEventListener('click', function(e){
        var pill = e.target.closest('[data-opt-value]'); if(!pill) return; e.preventDefault();
        selected[idx] = pill.getAttribute('data-opt-value');
        group.querySelectorAll('[data-opt-value]').forEach(function(p){ p.setAttribute('aria-pressed', p===pill?'true':'false'); });
        var cur = group.querySelector('[data-opt-current]'); if(cur){ cur.textContent = pill.getAttribute('data-opt-value'); }
        if(group.getAttribute('data-is-color')==='true'){ var th=colorTheme(pill.getAttribute('data-opt-value')); if(th){ document.body.setAttribute('data-variant', th); } }
        update();
      });
    });
    var qty = document.getElementById('pdp-qty');
    var plus = document.getElementById('qPlus'), minus = document.getElementById('qMinus');
    if(plus){ plus.addEventListener('click', function(){ qty.value=(parseInt(qty.value,10)||1)+1; }); }
    if(minus){ minus.addEventListener('click', function(){ var n=(parseInt(qty.value,10)||1)-1; qty.value=n<1?1:n; }); }
    function addToCart(){
      var id = document.getElementById('variant-id').value;
      var q = parseInt((qty && qty.value) || 1, 10);
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:q}]})})
        .then(function(r){return r.json();}).then(function(){ refreshCart(); toast('Added to cart.'); })
        .catch(function(){ window.location.href='/cart'; });
    }
    form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    var mobileBtn = document.querySelector('[data-add-mobile]');
    if(mobileBtn){ mobileBtn.addEventListener('click', addToCart); }

    /* bundle selector → sets quantity */
    var bundle = document.querySelector('[data-bundle]');
    if(bundle){
      bundle.querySelectorAll('[data-bundle-qty]').forEach(function(row){
        row.addEventListener('click', function(){
          bundle.querySelectorAll('[data-bundle-qty]').forEach(function(r){ r.setAttribute('aria-pressed', r===row?'true':'false'); });
          if(qty){ qty.value = row.getAttribute('data-bundle-qty'); }
        });
      });
    }
    update();
  })();
})();
